// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M1.5 8.5L3.87 4.05C4.22 3.39 4.9 3 5.65 3H10.35C11.1 3 11.78 3.39 12.13 4.05L14.5 8.5V11C14.5 12.1 13.6 13 12.5 13H3.5C2.4 13 1.5 12.1 1.5 11V8.5Z',
  'M1.85 8.5H4.6C5.05 8.5 5.25 8.7 5.43 9.08L5.75 9.75C6.04 10.35 6.47 10.65 7.13 10.65H8.87C9.53 10.65 9.96 10.35 10.25 9.75L10.57 9.08C10.75 8.7 10.95 8.5 11.4 8.5H14.15',
];
